import api from "../axios";

export const createDining = (data) => api.post("/dining/create", data);
export const updateDining = (id, data) => api.put(`/dining/update/${id}`, data);
export const deleteDining = (id) => api.delete(`/dining/delete/${id}`);
export const getAllDining = (params) => api.get("/dining/all", { params });
export const getDiningBySlug = (slug) => api.get(`/dining/${slug}`);
export const adminGetAllDining = () => api.get("/dining/admin/all");
export const getRelatedDining = (id) => api.get(`/dining/related/${id}`);
